import { type AuthorisableUser, hasRole } from 'policies/entities/user';
import { explicitlyAllocatedMarkerRoles } from './mark.policy';
import { markingAllocationRoles } from './marking-allocation.policy';

// Helper functions (don't use these directly for authorising actions; use a policy action):
export function hasMarkingTaskRole(user: AuthorisableUser): boolean {
  const viewMarkingTaskRoles = markingAllocationRoles.concat(explicitlyAllocatedMarkerRoles);
  return hasRole(user, viewMarkingTaskRoles);
}

/**
 * Authorisation rules for the resource that the policy is named after.
 * Functions return true only if the user can perform the action.
 * Follows the policy pattern used in Gate (Laravel) and Pundit (Rails).
 */
export default class MarkingTaskPolicy {
  static list(user: AuthorisableUser): boolean {
    if (!user.belongsToMarkingOrganisation) return false;
    return hasMarkingTaskRole(user);
  }

  /**
   * Permits action if user can perform administrative tasks to marking tasks such as overriding the
   * status of a Mark, viewing deallocation and delete buttons, etc.
   */
  static administrate(user: AuthorisableUser): boolean {
    return hasRole(user, markingAllocationRoles);
  }
}
